<template>
  <UploadImg
    ref="upload"
    :auto-upload="autoUpload"
    :need-crop="needCrop"
    :aspect-ratio="aspectRatio"
    :output-type="outputType"
    :center-box="centerBox"
    :clz-name="clzName"
    @startUpload="startUpload"
    @uploadSuccess="uploadSuccess"
    @uploadFail="uploadFail"
    @imageSelected="imageSelected"
    @imageCropped="imageCropped"
  />
</template>

<script>
import UploadImg from './tip-match-upload-img-@TIP_PLATFORM_NAME';

export default {
  name: 'TipMatchUploadImgComp',
  components: {
    UploadImg,
  },
  props: {
    autoUpload: {
      type: Boolean,
      default: true,
    },
    needCrop: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: 1,
    },
    outputType: {
      type: String,
      default: 'png',
    },
    centerBox: {
      type: Boolean,
      default: false,
    },
    clzName: {
      type: String,
      default: '',
    },
  },
  emits: ['startUpload', 'uploadSuccess', 'uploadFail', 'imageSelected', 'imageCropped'],
  data() {
    return {};
  },
  mounted() {

  },
  methods: {
    startUpload() {
      this.$emit('startUpload');
    },
    uploadSuccess(data) {
      this.$emit('uploadSuccess', data);
    },
    uploadFail(data) {
      this.$emit('uploadFail', data);
    },
    imageSelected(file) {
      this.$emit('imageSelected', file);
    },
    imageCropped(data) {
      this.$emit('imageCropped', data);
    },
    uploadCroppedData() {
      this.$refs.upload.uploadCroppedData();
    },
    // 跨组件传文件可给这个方法传参
    uploadCompressFile(file) {
      this.$refs.upload.uploadCompressFile(file);
    },
  },
};
</script>

<style scoped>

</style>
